import type { PriceInfo } from "epsm-api-types/ws";
import type { UTCTimestamp } from "lightweight-charts";
import { ONE_DAY_IN_MS } from "@/lib/utils";

export const convertQuarterToDaily = (
	quarterData: PriceInfo<UTCTimestamp>[],
	from: number,
	to: number,
): PriceInfo<UTCTimestamp>[] => {
	const dailyData: PriceInfo<UTCTimestamp>[] = [];
	let quarterIndex = 0;

	for (let t = from; t <= to; t += ONE_DAY_IN_MS) {
		while (
			quarterIndex < quarterData.length &&
			t >= quarterData[quarterIndex].time
		) {
			quarterIndex++;
		}

		const quarter = quarterData[quarterIndex];

		dailyData.push({
			...quarter,
			time: t as UTCTimestamp,
		});
	}

	return dailyData;
};
